import { useQuery } from '@tanstack/react-query'
import { useUserContext } from '~/contexts/UserContext'
import { useWorkspaceContext } from '~/contexts/WorkspaceContext'
import { getConnectionStatus } from '~/services/organizationService'
import { QueryKeys } from '~/services/queryClient'

export function useConnectionStatus() {
  const { currentWorkspace } = useWorkspaceContext()
  const { user } = useUserContext()

  // Skip connection status check if email not verified
  const isEmailVerified = user?.email_verified === true

  return useQuery({
    queryKey: [QueryKeys.ConnectionStatus, currentWorkspace?.uuid],
    queryFn: () => {
      if (!currentWorkspace?.uuid) throw new Error('Workspace not found')
      return getConnectionStatus(currentWorkspace.uuid)
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
    enabled: !!currentWorkspace?.uuid && isEmailVerified
  })
}
